export default __webpack_public_path__ + "static/media/logo_short.a022eff4.svg";